import React from 'react';
import classnames from 'classnames';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import Sticky from '@wix/da-shared-react/pkg/Sticky';
import shortenNumber from '@wix/da-ds/pkg/utils/shortenNumber';
import { BiDataHook } from '@wix/da-bi/pkg/constants';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';

import cssVars from '@wix/da-ds/src/styles/variables.scss';
import profilesCssVars from '../../../../styles/variables.scss';
import s from './WidgetHeaderMobile.scss';

export interface Props {
  header: string | React.ReactNode;
  count?: number | string;
  extras?: React.ReactNode | React.ReactNode[];
  extrasWhenSticky?: React.ReactNode | React.ReactNode[];
  isSticky?: boolean;
  className?: string;
  rootClassName?: string;
  isWide?: boolean;
}

const WidgetHeaderMobile: React.FC<Props> = ({
  className,
  isSticky,
  header,
  count,
  extras,
  extrasWhenSticky,
  rootClassName,
  isWide = false,
}) => {
  const isUpdatedVersion = useFlag('profile_mobile_heading');

  // T42244: The sticky headers get stuck a pixel too low sometimes
  const marginTop =
    parseInt(cssVars['site-header-height-mobile']) +
    parseInt(profilesCssVars['mobile-navbar-height']) -
    1;

  const shouldRenderAsHeading = !!header;
  const Tag = shouldRenderAsHeading ? Heading : 'div';
  const renderInner = (isStuck = false) => (
    <div
      className={classnames(
        s['root'],
        isStuck && s['is-stuck'],
        isWide && s['is-wide'],
        isUpdatedVersion && s['v2'],
        rootClassName
      )}
    >
      <Tag className={s['header']} data-hook={BiDataHook.WIDGET_HEADER}>
        {header}
        {!!count && (
          <span
            className={s['count']}
            data-hook={BiDataHook.WIDGET_HEADER_COUNTER}
          >
            {shortenNumber(count)}
          </span>
        )}
      </Tag>
      {extras}
      {isStuck && extrasWhenSticky}
    </div>
  );

  return (
    <div className={classnames(s['wrapper'], className)}>
      {isSticky ? (
        <Sticky className={'sticky'} marginTop={marginTop}>
          {isStuck => renderInner(isStuck)}
        </Sticky>
      ) : (
        renderInner()
      )}
    </div>
  );
};
WidgetHeaderMobile.displayName = 'WidgetHeaderMobile';

export default WidgetHeaderMobile;
